<div class="experience-poll-modal bg-am-medium-blue">
  <app-am-experience-poll
    [reservationCode]="reservationCode"
    (ratingSelected)="onRatingSelected($event)"
  ></app-am-experience-poll>
</div>
